REFERRAL_TRACKING_QUERY_VARS